import './directory-list';
import './filter';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
const { isEmpty } = _uo.utility;

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.itemLoop;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop-filters' )
export class AutomatorBuilderItemLoopFilters extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The unique ID of this loop block
	@property( { type: Number, attribute: 'loop-id' } ) accessor id;

	// Information about what has to be iterated (e.g. users, posts, tokens)
	@property( { type: Object, attribute: false } ) accessor iterableExpression;

	// The loop filters
	@property( { type: Array, attribute: false } ) accessor loopFilters = [];

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="filters">
				${ this._templateItems }
				${ this._templateActions }
			</div>            
		`;
	}

	/**
	 * Renders the list of filters
	 *
	 * @return {TemplateResult|undefined} The list of filters
	 */
	get _templateItems() {
		// Check if there are filters at all
		if ( this.loopFilters.length === 0 ) {
			return;
		}

		return html`
			<div class="filters-items">
				${ repeat(
					this.loopFilters,
					loopFilter => loopFilter.id,
					loopFilter => html`
						<uap-builder-item-loop-filter
							loop-id=${ this.id }
							loop-filter-id=${ loopFilter.id }
							loop-filter-code=${ loopFilter.code }
							integration-code=${ loopFilter.integration_code }

							.fields=${ loopFilter.fields }
							.backup=${ loopFilter.backup }
						></uap-builder-item-loop-filter>
					`
				) }
			</div>
		`;
	}

	/**
	 * Renders the list of actions
	 *
	 * @return {TemplateResult} The footer with the actions
	 */
	get _templateActions() {
		return html`
			<uap-builder-item-loop-add-filter-button
				loop-id=${ this.id }
				.iterableExpression=${ this.iterableExpression }
			></uap-builder-item-loop-add-filter-button>
		`;
	}
}